import { type ReactElement } from 'react';
import { Text } from '@mantine/core';
import { useAssistFilters } from '@/shared/surfaces/assist/AssistSurfaceProvider';
import { useDIContainer } from '@/container/RouteContainerProvider';
import { useGlobalFilterKey } from '@/features/global-filters/useGlobalFilters';
import { SurfaceSignalCatalog } from './SurfaceSignalCatalog';
import SignalTileGrid from './SignalTileGrid';

interface SurfaceSignalGridProps {
    surfaceId: string;
}

/**
 * The default tile layout for a surface's landing page: the surface's registry
 * tiles rendered under the ambient assist filters. A thin wrapper over
 * {@link SignalTileGrid}, which carries the loading→live rendering (with the
 * sample as fallback).
 */
export default function SurfaceSignalGrid({ surfaceId }: SurfaceSignalGridProps): ReactElement {
    const defs = useDIContainer().resolve(SurfaceSignalCatalog).signalsFor(surfaceId);
    const filters = useAssistFilters();
    const scopeKey = useGlobalFilterKey();

    if (defs.length === 0) {
        return (
            <Text size="sm" c="dimmed">
                No signals configured for this surface yet.
            </Text>
        );
    }

    return <SignalTileGrid defs={defs} filters={filters} scopeKey={scopeKey} />;
}
